<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  components: {},
}
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-y: hidden;
}
.page-list-search {
  background-color: #ffffff;
  height: auto;
}
.page-list-search .first-search-item {
  margin-left: 1rem;
}
.page-list-search .top-item {
  margin-top: 0.5rem;
}
/* 去除input type=number右侧的小箭头 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type='number'] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
.notset {
  text-decoration: line-through;
  color: darkgray;
}
/* 单多选按钮选中颜色 */
.el-radio__input.is-checked .el-radio__inner,
.el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #1777ff;
  background-color: #1777ff;
}
/* 单多选按钮选中文本颜色/primary按钮文本颜色/下拉框选中文本 */
.el-radio__input.is-checked + .el-radio__label,
.el-checkbox__input.is-checked + .el-checkbox__label,
.el-button--primary.is-text,
.el-select-dropdown__item.selected {
  color: #1777ff;
}
/* primary按钮颜色/按钮组 */
.el-button--primary,
.el-radio-button__original-radio:checked + .el-radio-button__inner {
  background-color: #1777ff;
  border-color: #1777ff;
  color: white;
}
.exam-dialog .el-dialog__header {
  margin-right: 0;
  background: #f2f3f5;
}
.plan-btn{
  border: 1px solid #88909B;color: #2C2C2C;
}
/* 分页上一页/下一页按钮加内边距 */
.el-pagination .btn-prev,
.el-pagination .btn-next {
  padding: 0 10px !important;
  min-width: 60px !important;
}
</style>
